import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import "draft-js/dist/Draft.css";
import TextEditor from "./textEditor/TextEditor";
import { Button, DialogActions, Typography } from "@material-ui/core";
import htmlToDraft from "html-to-draftjs";
import _ from "lodash";
import draftToHtml from "draftjs-to-html";

export interface HtmlEditorProps {
  open: boolean;
  handleClose: any;
  htmlEditorState: any;
  handleSubmitEditorState: any;
  setBackgroundColor: any;
  backgroundColor: any;
  title: any;
  subTitle: any;
}

/* Using this component, changes to the banner title and subtitle are made using an HTML editor. 
   Here, the title and subtitle font style can be changed.  */
const HtmlEditor: React.FunctionComponent<HtmlEditorProps> = ({
  open,
  handleClose,
  htmlEditorState,
  handleSubmitEditorState,
  setBackgroundColor,
  backgroundColor,
  title,
  subTitle,
}) => {
  const [editorStateTitle, setEditorStateTitle] = React.useState(() =>
    EditorState.createEmpty(),
  );
  const [editorStateSubTitle, setEditorStateSubTitle] = React.useState(() =>
    EditorState.createEmpty(),
  );
  const [isDisable, setIsDisable] = React.useState(false);
  const [background, setBackground] = React.useState("");

  React.useEffect(() => {
    if (open && backgroundColor) {
      setBackground(backgroundColor);
    }
  }, [open]);

  /* Checking if values ​​exist in the editor. */
  React.useEffect(() => {
    const contentBlock = htmlToDraft(title);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
    );
    const editorStateTitle = EditorState.createWithContent(contentState);
    setEditorStateTitle(editorStateTitle);

    // Only if the editor has a value, the option to edit the banner or add a new banner is given.
    if (_.isEmpty(title)) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [title, open]);

  React.useEffect(() => {
    const contentBlock = htmlToDraft(subTitle);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
    );
    const editorStateSubTitle = EditorState.createWithContent(contentState);
    setEditorStateSubTitle(editorStateSubTitle);

    // Only if the editor has a value, the option to edit the banner or add a new banner is given.
    if (_.isEmpty(subTitle)) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [subTitle, open]);

  const handleChangeEditorStateTitle = (editorStateTitle: any) => {
    // Check whether the HTML editor has value or not.
    if (editorStateTitle.getCurrentContent().hasText()) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
    const rawContentState = convertToRaw(editorStateTitle.getCurrentContent());
    const html = draftToHtml(rawContentState);

    setEditorStateTitle(editorStateTitle);
  };

  const handleChangeEditorStateSubTitle = (editorStateSubTitle: any) => {
    // Check whether the HTML editor has value or not.
    if (editorStateSubTitle.getCurrentContent().hasText()) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
    const rawContentState = convertToRaw(
      editorStateSubTitle.getCurrentContent(),
    );
    const html = draftToHtml(rawContentState);

    setEditorStateSubTitle(editorStateSubTitle);
  };

  /* Submit the data after editing. */
  const handleSubmit = () => {
    /* Checking if the editor has a value. */
    if (!_.isEmpty(editorStateTitle) && !_.isEmpty(editorStateSubTitle)) {
      setBackgroundColor(background);
      handleSubmitEditorState(true, editorStateTitle);
      handleSubmitEditorState(false, editorStateSubTitle);
    }
  };

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={handleClose}>
      <Typography
        variant="h5"
        style={{ marginTop: "12px", marginLeft: "24px" }}
      >
        Title
      </Typography>
      <TextEditor
        editorState={editorStateTitle}
        handleChangeEditorState={handleChangeEditorStateTitle}
        setBackgroundColor={setBackground}
        backgroundColor={background}
        minHeight="100px"
      />

      <Typography
        variant="h5"
        style={{ marginTop: "12px", marginLeft: "24px" }}
      >
        Sub Title
      </Typography>
      <TextEditor
        editorState={editorStateSubTitle}
        handleChangeEditorState={handleChangeEditorStateSubTitle}
        setBackgroundColor={setBackground}
        backgroundColor={background}
        minHeight="200px"
      />
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button disabled={isDisable} onClick={handleSubmit} color="secondary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HtmlEditor;
